import { createFileRoute } from '@tanstack/react-router'

import { DigitalProductLandingPagesRules } from '@/features/public-pages/Rules'

export const Route = createFileRoute('/_event/p/regras')({
  staticData: {
    isPublic: true
  },
  component: DigitalProductLandingPagesRulesPage
})

function DigitalProductLandingPagesRulesPage() {
  return <DigitalProductLandingPagesRules />
}
